import { Box, Container, useTheme } from "@mui/material";
import React from "react";
export const FooterContainer = ({ children, sx = {} }) => {
    const theme = useTheme();
    return (React.createElement(Box, { component: "footer", id: "footer", sx: {
            backgroundColor: theme.palette.grey[800],
            boxShadow: "sectionTop",
            color: "white",
            pb: { xs: 10, lg: 14 },
            position: "relative",
            pt: { xs: 6, md: 8, lg: 12 },
            zIndex: 25,
            ...sx,
        } },
        React.createElement(Container, { maxWidth: false, sx: { maxWidth: theme.breakpoints.values.xl } }, children)));
};
//# sourceMappingURL=container.js.map